const pallete = {
  selected: 'rgb(127, 48, 245)',
  nocolor: 'rgba(67, 67, 94, 1)',
} as const;

type StrokeProps = {
  color?: string;
  selected?: boolean;
  size: number;
};

const Stroke = ({ color, selected, size }: StrokeProps) => {
  const getStroke = (color: string, selected: boolean) => {
    if (selected) return 'rgb(127, 48, 245)';
    return color === 'none' ? 'rgba(67, 67, 94, 1)' : color;
  };

  const centerFill = selected ? 'rgba(233, 241, 254, 1)' : 'rgba(234, 234, 237, 1)';
  const stroke = getStroke(color ?? 'none', selected ?? false);
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1914_5573)">
        <rect x="4" y="4" width="16" height="16" fill={centerFill} />
        <path
          d="M18 6V18H6V6H18ZM19.7778 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 3 21 2 19.7778 2Z"
          fill={color === 'none' ? pallete.nocolor : color}
        />
        <path
          d="M21.5 4C21.5 3.17157 20.8284 2.5 20 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V20C2.5 20.8284 3.17157 21.5 4 21.5H20C20.8284 21.5 21.5 20.8284 21.5 20V4Z"
          stroke={stroke}
        />
        {color === 'none' && (
          <path d="M4 20L20 4" stroke="#E93A51" strokeWidth="2" strokeLinecap="round" />
        )}
      </g>
      <defs>
        <clipPath id="clip0_1914_5573">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Stroke;
